import { api } from "../api";

import {
  ApiEntityRequestParams,
  ApiEntityResponse,
  SuppliersResponse,
  CustomersResponse,
  RequestCustomersParams,
} from "./types";

export async function getSuppliersApi(params?: {
  size: number;
}): Promise<SuppliersResponse> {
  const { data } = await api.get<SuppliersResponse>("/api/suppliers/names", {
    params,
  });
  return data;
}

export async function getCustomersApi(
  params?: RequestCustomersParams,
): Promise<CustomersResponse> {
  const { data } = await api.get<CustomersResponse>("/api/customers/names", {
    params,
  });
  return data;
}

export async function fetchApi<T>(
  url: string,
  params?: ApiEntityRequestParams,
): Promise<ApiEntityResponse<T>> {
  const { data } = await api.get<ApiEntityResponse<T>>(url, { params });
  return data;
}

export async function fetchRaw<T>(url: string): Promise<T> {
  const { data } = await api.get<T>(url);
  return data;
}
